const links = {
    wiki: 'https://w.amazon.com/bin/view/AWS_EventEngine',
    featureRequest:
        'https://issues.amazon.com/issues/create?template=2ab2906e-ab0a-43be-8b30-950dc5108a43',
    reportBug:
        'https://t.corp.amazon.com/create/templates/3a903712-d081-42b4-a522-8176a42de95e',
    privacy: 'http://aws.amazon.com/privacy',
    terms: 'http://aws.amazon.com/terms',
    awsCLIUserGuide:
        'https://docs.aws.amazon.com/cli/latest/userguide/cli-chap-welcome.html',
};

export default links;
